import request from "../../untils/request.js"


//分页
export const getChinaMedicineListPage = (params) => {
    return request.get('/outpatient/tcmrxmain/page',{params})
}

export default{
}

